module.exports = __webpack_public_path__ + "media/newstyle/images/emotional-analysis_background-ca83b86a8f3cd9e689f31837e098310d.png";